<template>
  <div>
    <div style="height: 100%">
      <yandex-map
        :coords="centerMap"
        zoom="5"
        style="position: absolute; width: 100%; height: 100%; z-index: 1000"
        :cluster-options="clusterOptions"
        :cluster-callbacks="{ 1: { balloonopen: bindListener } }"
        show-all-markers
        :controls="['typeSelector', 'geolocationControl', 'zoomControl']"
      >
        <template v-for="point in pointsNoro">
          <ymap-marker
            :key="point.id"
            marker-type="placemark"
            :icon="point.icon"
            :marker-id="point.id"
            :coords="[point.lat, point.lon]"
            :hint-content="point.name"
            :options="{
              hasBalloon: false,
            }"
            :balloon="{ header: point.name }"
            cluster-name="1"
            autofocus
            @click="clickOnPoint(point)"
          >
          </ymap-marker>
        </template>
      </yandex-map>
      <div id="air_legend">
        <div style="display: flex; align-items: center">
          <b v-if="legendIsOpen">Обозначения:</b>
          <v-spacer />
          <v-btn text @click="legendIsOpen = !legendIsOpen">{{
            legendIsOpen ? "скрыть" : "показать легенду"
          }}</v-btn>
        </div>
        <div v-if="legendIsOpen">
          <img src="../assets/green-point.png" alt="зеленая метка" />
          -
          <i>свалка ликвилированна</i>
          <br />
          <img src="../assets/red-point.png" alt="красная метка" />
          -
          <i>свалка активна</i>
          <br />
        </div>
      </div>
      <div
        v-if="isOpenBalloon"
        style="
          position: absolute;
          align-items: center;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: row-reverse;
        "
      >
        <div v-bind:class="[isMobile() ? 'isMobileBalloon' : 'balloon']">
          <div style="width: min-content">
            <v-btn
              :ripple="false"
              icon
              @click="
                isOpenBalloon = false;
                selectedNoro = null;
              "
            >
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
            <v-btn
              v-if="contains(perm, 'noro:object:e')"
              :ripple="false"
              icon
              @click="
                $router.push({
                  name: 'noro-edit',
                  params: { id: selectedNoro.id },
                })
              "
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
          <div style="overflow-y: scroll; padding: 2px">
            <h3>{{ this.selectedNoro.name }}</h3>
            <table>
              <tbody>
                <tr>
                  <td>Статус</td>
                  <td>
                    {{
                      this.selectedNoro.isLiquidated
                        ? "Ликвидированна"
                        : "Активна"
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Тип НОРО</td>
                  <td>{{ this.selectedNoro.typeNORO }}</td>
                </tr>
                <tr>
                  <td>
                    Наименование муниципального образования Красноярского края
                  </td>
                  <td>{{ this.selectedNoro.nameMunicipality }}</td>
                </tr>
                <tr>
                  <td>Кадастровый номер</td>
                  <td>{{ this.selectedNoro.cadastralNumber }}</td>
                </tr>
                <tr>
                  <td>Растояние до ближайшего населенного пункта, м</td>
                  <td>{{ this.selectedNoro.distanceToTown }}</td>
                </tr>
                <tr>
                  <td>Площадь, га</td>
                  <td>{{ this.selectedNoro.square }}</td>
                </tr>
                <tr>
                  <td>Собственник земельного участка</td>
                  <td>{{ this.selectedNoro.landOwner }}</td>
                </tr>
                <tr>
                  <td>Состоит на учете ГРОНВОС</td>
                  <td>
                    {{ this.selectedNoro.availabilityInGRONVOS ? "Да" : "Нет" }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Состоит на учете в териториальной схеме обращения с отходами
                  </td>
                  <td>
                    {{
                      this.selectedNoro.availabilityInTerSchema ? "Да" : "Нет"
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Дата основания</td>
                  <td>{{ dateFormatted(this.selectedNoro.dateFoundation) }}</td>
                </tr>
                <tr>
                  <td>Дата выявления</td>
                  <td>{{ this.selectedNoro.dateDiscovery }}</td>
                </tr>
                <tr v-if="this.selectedNoro.availabilityInGRONVOS">
                  <td>Дата включения в ГРОНВОС</td>
                  <td>
                    {{
                      dateFormatted(this.selectedNoro.dateOfInclussionInGronvos)
                    }}
                  </td>
                </tr>
                <tr
                  v-if="
                    this.selectedNoro.isLiquidated &&
                    this.selectedNoro.dateLiquidation
                  "
                >
                  <td>Дата ликвидации</td>
                  <td>
                    {{ dateFormatted(this.selectedNoro.dateLiquidation) }}
                  </td>
                </tr>
                <tr>
                  <td>Заметка</td>
                  <td>{{ this.selectedNoro.note }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { yandexMap, ymapMarker } from "vue-yandex-maps";
import { isMobile } from "mobile-device-detect";
import axios from "axios";

export default {
  name: "noro-view",
  components: {
    yandexMap,
    ymapMarker,
  },
  data() {
    return {
      centerMap: [56.0184, 92.8672],
      legendIsOpen: true,
      isOpenBalloon: false,
      pointsNoro: [],
      clusterOptions: {
        1: {
          clusterDisableClickZoom: false,
          clusterOpenBalloonOnClick: true,
          clusterIconLayout: "default#pieChart",
          clusterIconPieChartRadius: 15,
          clusterIconPieChartCoreRadius: 10,
          clusterIconPieChartStrokeWidth: 1,
          clusterBalloonLayout: [
            "<ul class=list>",
            "{% for geoObject in properties.geoObjects %}",
            '<li><a pointId="{{geoObject.properties.markerId}}" class="cluster_list_item">{{ geoObject.properties.balloonContentHeader|raw }}</a></li>',
            "{% endfor %}",
            "</ul>",
          ].join(""),
        },
      },
      selectedNoro: {},
    };
  },
  computed: {
    perm() {
      return this.$store.getters.permissions || [];
    },
  },
  methods: {
    contains: function (arr, elem) {
      return arr.indexOf(elem) !== -1;
    },
    bindListener() {
      const points = document.getElementsByClassName("cluster_list_item");
      let fn;
      for (let i = 0; i < points.length; i++) {
        fn = () => {
          const id = points[i].getAttribute("pointId");
          return this.clickOnPoint(this.getPointById(id));
        };
        points[i].addEventListener("click", fn);
      }
    },
    isMobile() {
      return isMobile;
    },
    dateFormatted(date) {
      date = date?.replace("T", " ");
      date = date?.replace("Z", "");
      return date;
    },
    getPointById(id) {
      return this.pointsNoro.filter((item) => item.id == id)[0];
    },
    clickOnPoint(point) {
      this.centerMap = [point.lat, point.lon];
      axios
        .post("/noro/get/", {}, { params: { id: point.id } })
        .then((noroData) => {
          this.selectedNoro = noroData.data;
          this.isOpenBalloon = true;
        });
    },
    getPoints() {
      axios.post("/noro/points/get").then((response) => {
        this.pointsNoro = response.data;
        this.pointsNoro.forEach((item, index, arr) => {
          if (item.isLiquidated) {
            arr[index].icon = {
              color: "green",
              glyph: "Dot",
            };
          } else {
            arr[index].icon = {
              color: "red",
              glyph: "Dot",
            };
          }
        });
      });
    },
  },
  mounted() {
    this.getPoints();
  },
};
</script>

<style scoped>
.balloon {
  box-shadow: 0 0 11px 1px #ccc;
  display: flex;
  border: 1px solid lightgrey;
  position: absolute;
  padding-block: 10px;
  max-width: 40%;
  max-height: 80%;
  background: #ffffff;
  z-index: 1001;
}

.isMobileBalloon {
  box-shadow: 0 0 11px 1px #ccc;
  display: flex;
  border: 1px solid lightgrey;
  padding-block: 10px;
  max-width: 100%;
  max-height: 100%;
  background: #ffffff;
  z-index: 1002;
}
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  height: auto;
}
table td,
table th {
  border: 1px solid #595959;
  padding: 3px;
}
#air_legend {
  background-color: #ffffff;
  padding: 7px;
  border: 1px solid #7799d8;
  border-radius: 200px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -khtml-border-radius: 10px;
  position: absolute;
  left: 10px;
  max-width: 320px;
  bottom: 50px;
  z-index: 1001;
  overflow: hidden;
}
</style>
